import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, SelectPicker, Input, Nav, DatePicker, ControlLabel } from 'rsuite'
import { Controller, useForm } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import {
  exportAnnualTaxRemittance,
  exportAnnualTaxRemittanceText,
  getAnnualTaxRemittance,
  saveAnnualTaxRemittance,
} from '../../redux/actions/eFilling'
import { downloadFile } from '../../utils/fileUtil'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import PrePaymentList from './PrePaymentList'
import PaymentList from './PaymentList'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import PostPaymentList from './PostPaymentList'
import moment from 'moment'
import { DATE_FORMAT } from '../../constants/date'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { getValueFromOptions } from '../../utils/dataUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'

export default function AnnualTaxRemittanceWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const projectCode = sessionStorage.getItem('projectCode')
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const [isLoading, setIsLoading] = useState(false)
  const [txtModelTypeVal, setTxtModelTypeVal] = useState(0)
  const [projectCodeVal, setProjectCodeVal] = useState()
  const [contractNoVal, setContractNoVal] = useState()
  const [taxMonthVal, setTaxMonthVal] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [active, setActive] = useState(1)
  const [schema1, setSchema1] = useState()
  const [schema2, setSchema2] = useState()
  const [schema3, setSchema3] = useState()
  const [schemaPersons, setSchemaPersons] = useState()
  const [requestExport, setRequestExport] = useState()
  const [isSetProjectCode, setIsSetProjectCode] = useState(false)
  const [exportTextFile, setExportTextFile] = useState()

  useEffect(() => {
    if (props.schema) {
      // setSchema1(props.schema.prePaymentList)
      // setSchema2(props.schema.paymentList)
      // setSchema3(props.schema.postPaymentList)

      setIsSetProjectCode(props?.schema?.searchForm?.projectCode?.isSetProjectCode || false)
      setTxtModelTypeVal(formSchema?.searchForm?.modelType?.value || 1)

      if (props?.schema?.searchForm?.projectCode?.isSetProjectCode) {
        setProjectCodeVal(projectCode || '')
      }
    }
  }, [props.schema])

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await exportAnnualTaxRemittance(request)

      if (file) {
        downloadFile(file, file.name || `ข้อมูลรายการนำส่งภาษีรายปี.xlsx`)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSelect = (activeKey, item, index, e) => {
    // console.log('handleSelect ==>', activeKey)
    setActive(activeKey)
    // setTxtModelTypeVal(0)
    // setProjectCodeVal('')
    // setTaxMonthVal('')
    // setContractNoVal('')
    // setStartDate('')
    // setEndDate('')

    // let request = {
    //   withholdingType: null,
    //   projectCode: '',
    //   taxMonth: '',
    //   contractNo: '',
    //   submitStartDate: '',
    //   submitEndDate: '',
    //   status: activeKey,
    // }
    let request = {
      withholdingType: getValueFromOptions(
        formSchema.searchForm.modelType.options,
        txtModelTypeVal || null
      ),
      withholdingTypeValue: txtModelTypeVal,
      projectCode: projectCodeVal || '',
      taxMonth: taxMonthVal ? moment(taxMonthVal).format(DATE_FORMAT) : '',
      contractNo: contractNoVal || '',
      submitStartDate: startDate ? moment(startDate).format(DATE_FORMAT) : '',
      submitEndDate: endDate ? moment(endDate).format(DATE_FORMAT) : '',
      status: activeKey,
    }
    setRequestExport(request)
    onSearch(request)
  }

  const CustomNav = ({ active, onSelect, ...props }) => {
    return (
      <Nav {...props} activeKey={active} onSelect={onSelect}>
        <Nav.Item eventKey={1}>รายการรอส่งภาษีรายปี</Nav.Item>
        <Nav.Item eventKey={2}>รายการนำส่ง</Nav.Item>
        <Nav.Item eventKey={3}>รายการนำส่งสำเร็จ</Nav.Item>
      </Nav>
    )
  }

  const handleSearch = async () => {
    if (txtModelTypeVal === null || txtModelTypeVal === undefined || txtModelTypeVal === '') {
      let errMsg =
        formSchema?.searchForm?.modelType?.validators.filter(
          (item) => item.type === 'REQUIRED'
        )[0] || ''

      setError(formSchema.searchForm.modelType.name, {
        message: errMsg?.errorMessage || 'กรุณาเลือกรายการ',
        type: 'required',
      })
      return
    } else {
      clearErrors()
    }

    let request = {
      withholdingType: getValueFromOptions(
        formSchema.searchForm.modelType.options,
        txtModelTypeVal || null
      ),
      withholdingTypeValue: txtModelTypeVal,
      projectCode: projectCodeVal || '',
      taxMonth: taxMonthVal ? moment(taxMonthVal).format(DATE_FORMAT) : '',
      contractNo: contractNoVal || '',
      submitStartDate: startDate ? moment(startDate).format(DATE_FORMAT) : '',
      submitEndDate: endDate ? moment(endDate).format(DATE_FORMAT) : '',
      status: active,
    }
    // console.log('handleSearch request==>', request)
    setRequestExport(request)
    // console.log('+++++requestExportrequest ==>', requestExport)
    onSearch(request)
    // setError({})
  }

  const handleCancel = async () => {
    // console.log('handleCancel')
    setTxtModelTypeVal(1)
    setProjectCodeVal(isSetProjectCode ? projectCode : '')
    setTaxMonthVal('')
    setContractNoVal('')
    setStartDate('')
    setEndDate('')
    setSchema1()
    setSchema2()
    setSchema3()
    setSchemaPersons()

    let request = {
      withholdingType: null,
      projectCode: '',
      taxMonth: '',
      contractNo: '',
      submitStartDate: '',
      submitEndDate: '',
      status: active,
    }

    clearErrors()
    // onSearch(request)
  }

  const onSearch = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAnnualTaxRemittance(request)

      setSchema1(response?.model?.forms?.prePaymentList)
      setSchema2(response?.model?.forms?.paymentList)
      setSchema3(response?.model?.forms?.postPaymentList)
      setSchemaPersons(response?.model?.forms?.paymentList?.personsValues)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleOnSubmit = async (data) => {
    const request = {
      ids: data.ids,
      submitType: data.buttonType,
      status: active,
    }
    if (data.buttonType == true) {
      request.dateReceipt = data.dateReceipt || ''
      request.dateSubmission = data.dateSubmission || ''
      request.receiptNumber = data.receiptNumber || ''
      request.referenceNumber = data.referenceNumber || ''
    }
    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)

    try {
      let response = await saveAnnualTaxRemittance(request)
      if (response) {
        // clearValues()

        setFormSchema(response.model.forms)
        onSearch(requestExport)
        // console.log('responseTest', response)
      } else {
        // setIsError('ไม่สำเร็จ')
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
        // e.response.data.errors?.message ||
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const headerMap = {
    1: 'ค้นหารายการรอส่งภาษีรายปี',
    2: 'ค้นหารายการนำส่ง',
    3: 'ค้นหารายการนำส่งสำเร็จ',
  }

  const header = headerMap[active] || 'ค้นหา'

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        shaded
        // collapsible
        defaultExpanded
        bordered
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <Panel header={header} collapsible defaultExpanded bordered style={{ marginBottom: 20 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema.searchForm.projectCode.label}
              <Input
                value={projectCodeVal}
                onChange={(value) => {
                  setProjectCodeVal(value)
                }}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema.searchForm.contractNo.label}
              <Input
                value={contractNoVal}
                onChange={(value) => {
                  setContractNoVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.searchForm.modelType.validators,
                  formSchema.searchForm.modelType.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[formSchema.searchForm.modelType.name]} />
              <Controller
                name={formSchema.searchForm.modelType.name}
                control={control}
                defaultValue={formSchema?.searchForm?.modelType?.value || 1}
                rules={isValidators(formSchema.searchForm.modelType.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.searchForm.modelType.options}
                      // disabled={disabled}
                      value={props.value}
                      block
                      searchable={false}
                      placeholder={'เลือก' + formSchema.searchForm.modelType.label}
                      onChange={(value) => {
                        props.onChange(value)
                        setTxtModelTypeVal(value)
                      }}
                    />
                  )
                }}
              />
              {/* {formSchema.searchForm.modelType.label} */}
              {/* <SelectPicker
                searchable={false}
                value={txtModelTypeVal}
                data={formSchema.searchForm.modelType.options}
                block
                onChange={(value) => {
                  setTxtModelTypeVal(value)
                }}
              /> */}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema.searchForm.taxMonth.label}
              <DatePicker
                value={taxMonthVal}
                block
                format="MM/YYYY"
                ranges={[]}
                onOk={(e) => {
                  console.log(e)
                }}
                onChange={(value) => {
                  setTaxMonthVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema.searchForm.submitStartDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={startDate}
                onChange={(value) => {
                  setStartDate(value)
                }}
                disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema.searchForm.submitEndDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={endDate}
                onChange={(value) => {
                  setEndDate(value)
                }}
                disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 20, marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <SearchButton
                disabled={isLoading}
                onClick={handleSearch}
                style={{ marginTop: 0, marginLeft: 0 }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton onClick={handleCancel} style={{ marginTop: 0, marginLeft: 10 }}>
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </Panel>

        {schema1 && schema2 && schema3 && (
          <Panel collapsible defaultExpanded bordered>
            <CustomNav appearance="tabs" active={active} onSelect={handleSelect} />
            <Row style={{ textAlign: 'end', marginTop: 10 }}>
              {active == 1 && <PrePaymentList schema={schema1} handleOnSubmit={handleOnSubmit} />}

              {active == 2 && (
                <PaymentList
                  schema={schema2}
                  schemaPersons={schemaPersons}
                  handleOnSubmit={handleOnSubmit}
                  onExport={handleExportFile}
                  requestExport={requestExport}
                />
              )}

              {active == 3 && (
                <PostPaymentList
                  schema={schema3}
                  onExport={handleExportFile}
                  requestExport={requestExport}
                />
              )}
            </Row>
          </Panel>
        )}
      </Panel>
    </>
  )
}
